import * as React from 'react';
import { useSelector } from 'react-redux';

import { BASE_FILTERS_URL, SEO_URL_REGEXP } from '../../../common/constants/urls';
import { selectFiltersUrl } from '../../../common/selectors/urls';
import { IApplicationState } from '../../../common/types/redux';

/** Пауза перед переходом: даёт долететь аналитике клика и дорисоваться анимации нажатия */
const NAVIGATION_DELAY_MS = 300;

/**
 * Переход на страницу всех фильтров.
 *
 * Открыть их можно из двух мест — кнопки в ряду чипсов и иконки внутри полноразмерной
 * поисковой строки, — поэтому логика перехода живёт отдельно от обеих.
 */
export function useOpenFilters(): () => void {
  const filtersUrl = useSelector<IApplicationState, string | null>(selectFiltersUrl);

  return React.useCallback(() => {
    const isSeoUrl = SEO_URL_REGEXP.test(window.location.pathname);
    const searchStringFromLocation = window.location.search;
    const safeFiltersUrlFromState = filtersUrl || BASE_FILTERS_URL;

    setTimeout(() => {
      document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';

      if (isSeoUrl) {
        window.location.href = safeFiltersUrlFromState;
      } else if (searchStringFromLocation) {
        window.location.href = `/nd/search/${searchStringFromLocation}`;
      } else {
        window.location.href = safeFiltersUrlFromState;
      }
    }, NAVIGATION_DELAY_MS);
  }, [filtersUrl]);
}
